/**
 * Mounts app block markup (e.g. Instafeed) from an inert <template> when the section nears the viewport.
 * Content inside <template> does not load images or run scripts until mounted.
 */
(function () {
  if (window.__nexenLazyAppsInstafeedInit) return;
  window.__nexenLazyAppsInstafeedInit = true;

  function activateScripts(container) {
    container.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      for (var i = 0; i < oldScript.attributes.length; i++) {
        var attr = oldScript.attributes[i];
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function mount(root) {
    var tpl = root.querySelector('.apps-lazy-template');
    if (!tpl || root.hasAttribute('data-apps-lazy-mounted')) return;
    root.setAttribute('data-apps-lazy-mounted', '');

    var mountEl = document.createElement('div');
    mountEl.className = 'apps-lazy-mount';
    mountEl.appendChild(tpl.content.cloneNode(true));
    root.appendChild(mountEl);
    tpl.remove();
    activateScripts(mountEl);
  }

  function isNearViewport(el) {
    var r = el.getBoundingClientRect();
    var margin = 480;
    return r.top < window.innerHeight + margin && r.bottom > -margin;
  }

  function checkPendingRoots() {
    document.querySelectorAll('[data-apps-lazy-root]:not([data-apps-lazy-mounted])').forEach(function (root) {
      if (isNearViewport(root)) mount(root);
    });
  }

  var scrollScheduled = false;
  function scheduleViewportCheck() {
    if (scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(function () {
      scrollScheduled = false;
      checkPendingRoots();
    });
  }

  function init() {
    document.querySelectorAll('[data-apps-lazy-root]').forEach(function (root) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              obs.disconnect();
              mount(entry.target);
            });
          },
          { rootMargin: '400px 0px', threshold: 0 }
        );
        io.observe(root);
      }
    });

    window.addEventListener('scroll', scheduleViewportCheck, { passive: true });
    window.addEventListener('resize', scheduleViewportCheck, { passive: true });
    window.addEventListener('load', scheduleViewportCheck, { passive: true });
    scheduleViewportCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
